let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bgw5h")).then(() => parcelRequire('eeaty'));